import React from "react";
import { motion } from "framer-motion";

export const OutboundLink = ({ href, whileHover, children, ...props }) => {
    return (
        <motion.a href={href} whileHover={whileHover} rel="external nofollow noopener noreferrer" {...props}>
            {children}
        </motion.a>
    )
}